import React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cn } from "lib/utils";

const Progress = React.forwardRef(({ className, value, style, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      "relative h-2 w-full overflow-hidden rounded-full bg-[#e0e0e0]",
      className
    )}
    style={style} // allow dynamic styles
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="h-full w-full flex-1 transition-all"
      style={{
        transform: `translateX(-${100 - (value || 0)}%)`,
        backgroundColor: style?.["--progress-color"] || "var(--primary-icon)", // use the dynamic color
      }}
    />
  </ProgressPrimitive.Root>
));

Progress.displayName = "Progress";

export { Progress };